(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('AzureDashboardController', ["$scope", "$route", "path", "modulesManager", "widgetPolling", "sizeClasses", function ($scope, $route, path, modulesManager, widgetPolling, sizeClasses) {
        var page = 'ms_azure';
        var moduleApp = modulesManager.cloudApp(page);
        var appInfo = modulesManager.app(page);
        var title = 'Analytics';
        var hideAnalyticsSecurityStack = false;
        if (moduleApp) {
            title = (moduleApp.isSaas ? 'Analytics - ' : '') + moduleApp.title;
            modulesManager.currentModule(moduleApp.name);
        }
        if (appInfo) {
            hideAnalyticsSecurityStack = appInfo.hide_analytics_security_stack;
        }
        $route.current.fullTitle = title;
        $route.current.isSaas = moduleApp.isSaas;
        $route.current.name = moduleApp.name;
        if (moduleApp.img)
            $route.current.img = moduleApp.img;
        widgetPolling.updateWidgets(path('dashboard').ctrl('dashboard').json(page + '.dashboard').path, path('dashboard').ctrl('dashboard').json('common-widgets').path, {
            hideV1Only: true,
            infoboxesNoColor: true,
            showV2Only: true,
            hideAnalyticsSecurityStack: hideAnalyticsSecurityStack
        });
        $scope.widgetPolling = widgetPolling;
        $scope.getSizeClasses = sizeClasses;
    }]);
}());